import React from 'react';
import { Helmet } from 'react-helmet';

const INTERCOM_ID = 'e53mymim';

export default function Intercom({ language }) {
  return (
    <Helmet>
      <script defer type="text/javascript">
        {`
          var checkExist = setInterval(function() {
            if (window.Intercom) {
              var app_id = "${INTERCOM_ID}";
              Object.defineProperty(window, "cookies", {
              get: function() {
                    return document.cookie.split(';').reduce(function(cookies, cookie) {
              cookies[cookie.split("=")[0].trim()] = unescape(cookie.split("=")[1]);
                        return cookies
                    }, {});
                }
              });
              var intercomSettings = {app_id: app_id, language_override: '${language.shortName}' };
              if (cookies['intercom-settings']) {
                var is = JSON.parse(cookies['intercom-settings']);
                intercomSettings.app_id = is.app_id;
                intercomSettings.email = is.email;
                intercomSettings.user_hash = is.user_hash;
              }
              window.Intercom('boot', intercomSettings);
              clearInterval(checkExist);
            }
          }, 1000);
        `}
      </script>
    </Helmet>
  );
}